module.exports = __webpack_public_path__ + "img/2.0e1c017b.png";